import http from "./http"
const portalBasicApi = "/portalbasicapi";
const portalDataCollectionApi = "/portaldatacollectionapi";



export const Access = {
  GetVerifyCode: () => http.get(portalBasicApi + "/Access/GetVerifyCode"),
  Login: (params) => http.post(portalBasicApi + "/Access/Login", params),
  LoginOut: () => http.get(portalBasicApi + "/OnlineData/LoginOut"),
  CheckToken: (params) => http.post(portalBasicApi + "/Access/CheckToken", params),
}

export const License = {
  CheckLicenseState: () => http.get(portalBasicApi + "/License/CheckLicenseState")
}

export const SystemConfig = {
  GetSystemConfig: () => http.get(portalBasicApi + "/SystemConfig/GetConfig"),
  GetItem: () => http.get(portalBasicApi + "/SystemConfig/GetItem"),
}

export const Roles = {
  GetRoleByUser: () => http.get(portalBasicApi + "/Roles/GetRoleByUser")
}

export const UserLoginRedirectConfig = {
  GetItem: () => http.get(portalBasicApi + "/UserLoginRedirectConfig/GetItem"),
  SetItem: (params) => http.post(portalBasicApi + "/UserLoginRedirectConfig/SetItem", params),
  GetUserConfig: () => http.get(portalBasicApi + "/UserLoginRedirectConfig/GetUserConfig"),
}

export const Language = {
  GetLanguageType: () => http.get(portalBasicApi + "/Language/GetLanguageType"),
  GetLanguageByApp: () => http.get(portalBasicApi + "/Language/GetLanguageByApp"),
  SetLanguage: (lang) => http.post(portalBasicApi + "/Users/SetUserLanguage?language=" + lang),
}

export const Users = {
  GetItemSimpleByDepartMentId: (id) => http.get(portalBasicApi + "/Users/GetItemSimpleByDepartMentId/" + id),
  GetCurrentUser: () => http.get(portalBasicApi + "/Users/GetCurrentUser"),
  EditCurrentUser: (params) => http.post(portalBasicApi + "/Users/EditCurrentUser", params),
}

export const Message = {
  GetMessagePage: (params) => http.post(portalBasicApi + "/Message/GetMessagePage", params),
  GetMessageCollection: () => http.get(portalBasicApi + "/Message/GetMessageCollection"),


}

export const reportConfig = {
  GetMyReport: (params) => http.post(portalBasicApi + "/Product/ProductReportTree/GetMyReport", params),  //个人报表
  GetMyKpi: () => http.post(portalBasicApi + "/Product/ProductReportTree/GetMyKpi"),  // 个人KPI
  GetMyShares: () => http.get(portalBasicApi + "/Product/ProductReportTree/GetMyShares"), // 我的分享
  GetTree: () => http.get(portalBasicApi + "/Product/ProductReportTree/GetTree"), //公司报表
  GetReport: (params) => http.post(portalBasicApi + "/Product/ProductReportTree/GetReport", params),  //获取某一个   
  GetCollection: (Search) => http.get(portalBasicApi + "/BIServices/BIService/GetCollection/", Search), // 我的收藏
  GetBIReportMessage: (id) => http.get(portalBasicApi + "/BIServices/BIService/GetBIReportMessage/" + id),  //获取某一个  
  AddFavorite: (params) => http.post(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/AddMyFavoriteReport/" + params.ReportId +
    "/" + params.ProductReportGroupId, {}),  //报表详情添加到收藏 
  CancelFavorite: (params) => http.post(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/CancelFavoriteList", params),  //取消到收藏  
  CreateGroup: (params) => http.post(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/CreateItem", params), // 创建收藏分组
  GetGroupReportSearch: (search) => http.post(portalBasicApi + "/BIServices/ReportGroup/GetGroupReportSearch?GroupId=" + search.groupId + "&Search=" + search.search),
  FindReportByWord: (search) => http.post(portalBasicApi + "/Product/ProductReport/FindReportByWord", search), // 

}
export const homePage = {
  GetMyBrowseProductReport: (params) => http.post(portalBasicApi + "/BIServices/ReportGroup/GetMyBrowseProductReport", params), // 
  GuessLike: (params) => http.post(portalBasicApi + "/Product/ProductReport/GuessLike", params),
  /* 获取我的设计  */
  GetAppConfigs: () => http.get(portalBasicApi + "/Product/ProductReportTree/GetAppConfigs"),
  /* 我的发布 */
  GetMyPublishProductReportByUserId: (params) => http.post(portalBasicApi + "/BIServices/ReportGroup/GetMyPublishProductReportByUserId", params)
}

export const searchData = {
  GetHotKeyWord: (params) => http.post(portalBasicApi + "/Product/ProductReport/GetHotKeyWord", params),// 搜索的热点词汇
  GetUserFindLog: (params) => http.post(portalBasicApi + "/Product/ProductReport/GetUserFindLog", params), // 最近搜索
  ClearFindLog: () => http.get(portalBasicApi + "/Product/ProductReport/ClearFindLog") // 清除最近搜索
}

export const messages = {
  GetAnnouncement: (params) => http.post(portalBasicApi + "/Announcement/GetAnnouncement", params),// 获得消息
  GetAnnouncementItemById: (id) => http.get(portalBasicApi + "/Announcement/GetAnnouncementItemById/" + id), // 获得具体消息内容
  GetMessagePage: (params) => http.post(portalBasicApi + "/Message/GetMessagePage", params),// 获得消息
  GetFansMessageListPages: (params) => http.post(portalBasicApi + "/UserFans/GetFansMessageListPages", params),
  UpdateAnnouncementRead: (id) => http.get(portalBasicApi + "/Announcement/UpdateAnnouncementRead/" + id),
}

export const personal = {
  GetCurrentUser: () => http.get(portalBasicApi + "/Users/GetCurrentUser/"), // 获得个人信息
  EditCurrentUser: (params) => http.post(portalBasicApi + "/Users/EditCurrentUser", params), //设置个人信息
  LoginOut: () => http.get(portalBasicApi + "/OnlineData/LoginOut"),
  UserLoginRedirectGetItem: () => http.get(portalBasicApi + "/UserLoginRedirectConfig/GetItem"), //个人偏好获得
  UserLoginRedirectSetItem: (params) => http.post(portalBasicApi + "/UserLoginRedirectConfig/SetItem", params), //个人偏好设置
}



const dealParams = (datas) => {
  let dataStr = ""; //数据拼接字符串
  Object.keys(datas).forEach(key => {
    dataStr += key + "=" + datas[key] + "&";
  });
  return dataStr
}

export const Mycollection = {
  UpdateFile: (params) => http.get(portalBasicApi + "/BIServices/BIService/UpdateFile?" + dealParams(params)),
  GetAllEditInfoItemById: (ids) => http.get(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/GetAllEditInfoItemById/" + ids), //重命名
  EditItemFolder: (params) => http.post(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/EditItemFolder", params),   //重命名
  CancelFavoriteList: (params) => http.post(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/CancelFavoriteList", params),
  DeleteItemById: (params) => http.get(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/DeleteItemById/" + params),
  EditFavorite: (params) => http.post(portalBasicApi + "/Product/ProductReportFavorite/ProductReportFavorite/EditItem", params), //移动到其他分组的

}

export const TodoTask = {
  //获取待办任务列表
  GetToDoTaskList: (params) => http.post(
    portalDataCollectionApi + "/TodoTask/GetItems?UserId=" + params.UserId,
    params.queryPageInfo
  ),
  CheckTodoIsEdit: (id) => http.post(
    portalDataCollectionApi + "/TodoTask/CheckTodoIsEdit/" + id
  ),
  SaveFormDataInCheckView: (params) => http.post(
    portalDataCollectionApi + "/TodoTask/EditReportItem",
    params,
  ),
  DownloadFileInTodoTask: (id) => http.getBlobFile(portalDataCollectionApi + "/TodoTask/DownTemplateFile?templateId=" + id),
  IsMultiTemplateSheet: (id) => http.get(portalDataCollectionApi + "/TodoTask/IsMultiTemplateSheet", {
    reporsId: id, //TODO: 疑问参数，待核实
  }),
  GetItemById: (params) => http.get(`${portalDataCollectionApi}/TodoTask/GetItemById/${params.id}/${params.templateType}`),
  GetTemplateLastRecord: (params) => http.get(`${portalDataCollectionApi}/TodoTask/GetTemplatelastRecord/${params.templateID}/${params.userId}`),
}

export const TaskDone = {
  GetTaskDoneList: (params) => http.post(`${portalDataCollectionApi}/TaskDone/GetItems?userId=${params.UserId}`, params.queryPageInfo),
  TaskIsRevoke: (jobId) => http.post(`${portalDataCollectionApi}/TaskDone/CheckdoneTaskRevoke/${jobId}`),
  CheckFile: (params) => http.get(portalDataCollectionApi + "/TaskDone/CheckFile", params),
  DownloadFileInTaskDone: (id) => http.getBlobFile(portalDataCollectionApi + "/TaskDone/DownFile?Id=" + id),
}

export const WorkFlow = {
  AuditSubmitInTodoTask: (params) =>
    http.post(
      portalDataCollectionApi + "/WorkFlow/Approval",
      params,
    ),
  GetJobApprovalInfo: (params) => http.post(
    portalDataCollectionApi + "/WorkFlow/ApprovalInfo",
    params,
  ),
}

export const InitiationWorkFlow = {
  GetInitiationWorkFlowList: (params) => http.post(`${portalDataCollectionApi}/InitiationWorkFlow/GetItems?userId=${params.UserId}`,
    params.queryPageInfo,
  ),
}

export const TaskMonitor = {
  GetFlowInstanceProgress: (id) => http.get(
    portalDataCollectionApi + "/TaskMonitor/GetFlowInstanceProgress/" + id
  ),
  GetTaskMonitorItemById: (params) => http.get(`${portalDataCollectionApi}/TaskMonitor/GetItemById/${params.id}/${params.templateType}`),
  GetExcelDataListInTaskMonitor: (params) => http.post(`${portalDataCollectionApi}/TaskMonitor/GetExcelDataList`,
    params
  ),
  SaveReportExcelSheetData: (params) => http.post(
    portalDataCollectionApi + "/TaskMonitor/SaveReportExcelSheetData",
    params
  ),
  GetVerifyFailureRecord: (params) => http.post(portalDataCollectionApi + "/TaskMonitor/GetVerifyFailureRecord", params),
  GetDictionaryDataFilterData: (sheetID) => http.get(
    portalDataCollectionApi + "/TaskMonitor/GetDictionaryDataFilterData/" + sheetID
  )
}

export const Report = {
  InitiationProcessCreateReport: (params) => http.get(
    portalDataCollectionApi + "/Report/InitiationProcessCreateReport/" + params.id + "/" + params.userId
  )

}
